var exports = {
  "S": "x7f9a0e16--340832--region-suggest",
  "E": "x7f9a0e16--340832--suggests",
};

module.exports = exports;
